export default "/static/image/lanhu/sidebar/chevron.webp"